import { useState, useEffect } from 'react';

export default function WhatsAppPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const popupClosed = sessionStorage.getItem('whatsappPopupClosed');
    if (!popupClosed) {
      setTimeout(() => {
        setIsVisible(true);
      }, 3000);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setIsClosed(true);
    sessionStorage.setItem('whatsappPopupClosed', 'true');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/34628752701?text=Hola,%20me%20gustaría%20solicitar%20información%20sobre%20sus%20servicios', '_blank');
    handleClose();
  };

  if (!isVisible || isClosed) return null;

  return (
    <div className="fixed bottom-24 right-6 z-40 animate-bounce-in">
      <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 max-w-sm">
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 flex items-center justify-center w-6 h-6 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg"></i>
        </button>

        <div className="flex items-start gap-4 mb-4">
          <div className="flex items-center justify-center w-12 h-12 bg-green-500 rounded-full flex-shrink-0">
            <i className="ri-whatsapp-line text-2xl text-white"></i>
          </div>
          
          <div className="flex-1">
            <h3 className="text-base font-bold text-gray-900 mb-1">
              ¿Necesitas ayuda?
            </h3>
            <p className="text-sm text-gray-600">
              Chatea con nosotros por WhatsApp y te responderemos enseguida
            </p>
          </div>
        </div>

        <button
          onClick={handleWhatsApp}
          className="w-full px-5 py-3 bg-green-500 text-white text-sm font-medium rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
        >
          <i className="ri-whatsapp-line text-lg"></i>
          Iniciar conversación
        </button>

        <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white border-r border-b border-gray-200 transform rotate-45"></div>
      </div>
    </div>
  );
}